/**
 * Parses Magento `product_image` JSON (object map or array) into a usable image URL.
 */
export function resolveProductImageUrlFromJson(
  raw: string | null | undefined
): string | null {
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as unknown;
    const entries = Array.isArray(parsed)
      ? parsed
      : parsed && typeof parsed === 'object'
        ? Object.values(parsed)
        : [];

    const images = entries
      .filter(
        (
          entry
        ): entry is {
          medialink?: string;
          url?: string;
          productimagesorting?: string | number;
        } => Boolean(entry && typeof entry === 'object')
      )
      .filter((entry) => Boolean(entry.medialink || entry.url))
      .sort(
        (a, b) =>
          Number(a.productimagesorting ?? 0) -
          Number(b.productimagesorting ?? 0)
      );

    const first = images[0];
    const url = first?.medialink || first?.url || null;
    if (!url) {
      return null;
    }
    if (url.startsWith('//')) {
      return `https:${url}`;
    }
    return url;
  } catch {
    if (typeof raw === 'string' && raw.startsWith('http')) {
      return raw;
    }
    if (typeof raw === 'string' && raw.startsWith('//')) {
      return `https:${raw}`;
    }
    return null;
  }
}
